import Provider from '../ImportableObjects/Provider'
import Inventory from '../ImportableObjects/Inventory'
import Extract from '../ImportableObjects/Extract'
import Clinic from '../ImportableObjects/Clinic'
import Config from '../ImportableObjects/Config'
import User from '../ImportableObjects/User'

const exportableObjects = [Extract, Inventory, Provider, Clinic, User, Config]

export const getExporterMenu = () => {
  return exportableObjects.map(ClassInstance => {
    const item = new ClassInstance()
    return {
      getExport: item.apiDownloadExport,
      name: item._objectType
    }
  })
}
